import store from '../store';

export default function (to, from, next) {

    if (store.state.common.isLogin) {
        next({name: 'video'})
    } else {
        next()
    }
}
